import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { MatTabsModule } from '@angular/material/tabs';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { PAGELENGTH } from 'src/app/endpoints';
declare var bootstrap: any;

@Component({
  selector: 'app-company-distributors',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatTabsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    DatePipe,
    MatLabel,
    MatInputModule,
    RouterLink
  ],
  templateUrl: './company-distributors.component.html',
  styleUrl: './company-distributors.component.scss'
})
export class CompanyDistributorsComponent {
  // -------------------- Variables --------------------
  rtlUnderWhlModal: any;
  companyCustomersSampleModal: any;
  startpoint: number;
  companySearch: any;
  totalLoaded: number;
  total: any;
  pageNo: any;
  companyRes: any;
  companyId: any;
  allCategoriesMini: any;
  _id: any;
  pageSize: number = 10;
  companyDetail: any;
  singleDistributor: any;
  receiverType: number = 1;
  selectedRecipientType: any = 'Wholesaler';
  filter = { name: '', cityState: '' };
  debounceNameTimer: any = null;
  debounceBarCodeTimer: any = null;

  // -------------------- MatTable Setup --------------------
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['srno', 'name', 'contact', 'cordinates', 'address', 'samples', 'retailers'];
  displayedColumnsCustomer: string[] = ['srno', 'name', 'email', 'phone', 'age', 'gender', 'address', 'action'];

  RTLUnderWHLDataSource = new MatTableDataSource<any>([]);
  RTLUnderWHLdisplayedColumns: string[] = ['srno', 'name', 'email', 'phone', 'coordinates', 'address'];

  issuedSamplesToDistributorsDataSource = new MatTableDataSource<any>([]);
  issuedSamplesToDistributorsDisplayedColumns: string[] = ['srno', 'name', 'email', 'phone', 'quantityAssigned', 'quantityRemaining', 'distributorLimit'];

  issuedSamplesToCustomersDisplayedColumns: string[] = ['srno', 'name', 'email', 'phone', 'issuedQuantity'];

  companyCustomerSamplesDataSource = new MatTableDataSource<any>([]);
  companyCustomerSamplesdisplayedColumns: string[] = ['srno', 'sample', 'issuedByDistributorId', 'issuedQuantity', 'issueByHold', 'issuedAt'];

  // -------------------- Constructor --------------------
  constructor(
    private userService: UserServiceService,
    private companyService: CompanyService,
    private categoryService: CategoryService,
    private sampleService: SampleService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.companyId = this.activatedRoute.snapshot.paramMap.get("companyId");

    // Load initial data
    this.getAllDistributors(null);
    this.getSingleCompany(this.companyId);
    this.getAllCategoriesMini();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

    // Initialize Bootstrap modals
    const rtlUnderWhlModalElement = document.getElementById('rtlUnderWhlModal');
    if (rtlUnderWhlModalElement) {
      this.rtlUnderWhlModal = new bootstrap.Modal(rtlUnderWhlModalElement);
    }

    const companyCustomersSampleModalElement = document.getElementById('companyCustomersSampleModal');
    if (companyCustomersSampleModalElement) {
      this.companyCustomersSampleModal = new bootstrap.Modal(companyCustomersSampleModalElement);
    }
  }

  // Handles recipient type change and resets filters
  onRecipientChange(value: any) {
    this.selectedRecipientType = value;
    this.filter.name = null;
    this.filter.cityState = null;
    this.getAllDistributors(null);
  }

  // Debounced input change for name search
  onNameInputChange(event: any): void {
    const value = event.target.value.trim();
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      this.filter.name = value;
      if (!value) delete this.filter.name;
      this.getAllDistributors(null);
    }, 300);
  }

  // Debounced input change for address (city/state) search
  onBarAddressInputChange(event: any): void {
    const value = event.target.value.trim();
    clearTimeout(this.debounceBarCodeTimer);
    this.debounceBarCodeTimer = setTimeout(() => {
      this.filter.cityState = value;
      if (!value) delete this.filter.cityState;
      this.getAllDistributors(null);
    }, 300);
  }

  // Fetch mini categories for filters or other use
  getAllCategoriesMini() {
    this.categoryService.allCategoriesMini({}).subscribe({
      next: (result) => {
        if (result.success) this.allCategoriesMini = result.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  // Fetch single company details
  getSingleCompany(companyId: any) {
    this.companyService.singleCompany({ _id: companyId }).subscribe({
      next: (v: any) => {
        this.spinner.show();
        if (v.success) this.companyDetail = v.data;
        else console.log(v.message);
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => this.spinner.hide()
    });
  }

  // Fetch distributors or customers based on selectedRecipientType
  getAllDistributors(event: any): void {
    this.spinner.show();

    // Reset pagination on filter change or initial load
    if (!event || event?.pageSize !== this.pageSize) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = event?.pageSize || this.pageSize;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * this.pageSize;
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize,
      companyId: this.companyId,
      ...(this.companySearch && { search: this.companySearch }),
      ...(this.filter.name && { nameEmail: this.filter.name }),
      ...(this.filter.cityState && { cityState: this.filter.cityState })
    };

    // API selection based on recipient type
    let apiCall: any;
    if (this.selectedRecipientType === 'Customer') {
      apiCall = this.userService.companyCustomers(data);
    } else if (this.selectedRecipientType === 'Wholesaler') {
      apiCall = this.userService.allDistributor({ ...data, distributorType: 1 });
    } else if (this.selectedRecipientType === 'Retailer') {
      apiCall = this.userService.allDistributor({ ...data, distributorType: 2 });
    } else {
      this.spinner.hide();
      console.warn('Invalid recipient type selected:', this.selectedRecipientType);
      return;
    }

    // API response handling
    apiCall.subscribe({
      next: (result: any) => {
        if (result.success) {
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];
          this.totalLoaded = this.dataSource.data.length;

          // Update paginator values
          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize;
            }
          }, 0);
        }
      },
      error: (err) => this.toastr.error(err?.message || 'Failed to load distributors'),
      complete: () => this.spinner.hide()
    });
  }

  // Utility to calculate age from date of birth
  calculateAge(dob: string | Date): number {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  getTruncatedAddress(address: string = '', wordLimit: number = 4): string {
    const words = address.split(' ');
    return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : address;
  }

  // Opens the modal to show retailers under wholesaler
  openRtlUnderWhlModel(distributorId: any) {
    this.userService.singleDistributor({ _id: distributorId }).subscribe({
      next: (v: any) => {
        this.spinner.show();
        if (v.success) this.singleDistributor = v.data;
        else console.log(v.message);
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => this.spinner.hide()
    });

    this.getRTLUnderWHL(null, distributorId);
    this.rtlUnderWhlModal.show();
  }

  hideRtlUnderWhlModel() {
    this.rtlUnderWhlModal.hide();
  }

  // Fetch retailers under wholesaler
  getRTLUnderWHL(event: any, distributorId: any) {
    this.spinner.show();

    if (!event) {
      this.startpoint = 0;
      this.RTLUnderWHLDataSource.data = [];
    }

    const data: any = {
      startpoint: this.startpoint,
      companyId: this.companyId,
      distributorId,
      ...(this.companySearch && { search: this.companySearch })
    };

    if (this.totalLoaded === 0 || !event || ((this.totalLoaded < this.total) && (event.pageIndex > this.pageNo))) {
      this.userService.rtlUnderWhl(data).subscribe({
        next: (result) => {
          this.spinner.hide();
          if (result.success) {
            this.total = result.total ?? 0;
            this.RTLUnderWHLDataSource.data = [...this.RTLUnderWHLDataSource.data, ...(result.data || [])];
            this.totalLoaded = this.RTLUnderWHLDataSource.data.length;
            this.startpoint = this.totalLoaded;
            this.pageNo = this.paginator?.pageIndex;
            setTimeout(() => {
              this.paginator.length = this.total;
              this.paginator.pageSize = PAGELENGTH;
              this.paginator._changePageSize;
            }, 10);
          }
        },
        error: (e) => {
          this.spinner.hide();
          this.toastr.error(e);
        },
        complete: () => this.spinner.hide()
      });
    } else {
      this.spinner.hide();
    }
  }

  // Show modal for viewing customer samples
  openCompanyCustomersSampleModal(customerId: any) {
    this.companyCustomersSampleModal.show();
    this.getCopanyCustomersSample(null, customerId);
  }

  hideCompanyCustomersSampleModal() {
    this.companyCustomersSampleModal.hide();
  }

  // Fetch samples issued to customer
  getCopanyCustomersSample(event: any, customerId: any): void {
    this.spinner.show();
    if (!event || event?.pageSize !== this.pageSize) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = event?.pageSize || this.pageSize;
      this.companyCustomerSamplesDataSource.data = [];
      this.totalLoaded = 0;
    }
    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * this.pageSize;
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize,
      companyId: this.companyId,
      customerId,
      ...(this.companySearch && { search: this.companySearch })
    };

    this.sampleService.allIssuedSamplesToCustomer(data).subscribe({
      next: (result) => {
        this.spinner.hide();
        if (result.success) {
          this.total = result.total ?? 0;
          this.companyCustomerSamplesDataSource.data = result.data || [];
          this.totalLoaded = this.companyCustomerSamplesDataSource.data.length;
          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize;
            }
          }, 0);
        }
      },
      error: (e) => {
        this.spinner.hide();
        this.toastr.error(e.message || 'Failed to load samples');
      }
    });
  }


}
